import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';

// font-family: "Roboto", "Helvetica", "Arial", sans-serif;
// locale === 'ko';

function getFont(locale: string) {
  if (locale === 'ko')
    return ["'Noto Sans KR'", 'Helvetica', 'Arial', 'sans-serif'];
  return ['Roboto', 'Helvetica', 'Arial', 'sans-serif'];
}
const genTheme = (locale: string) =>
  createMuiTheme({
    typography: {
      fontFamily: getFont(locale).join(',')
    },
    palette: {
      primary: {
        main: '#5912fe'
      },
      secondary: {
        main: '#ffd809'
      },
      error: {
        main: red.A400
      },
      background: {
        default: '#fafaff'
      }
    },
    overrides: {
      // https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/Tabs/TabIndicator.js
      MuiTabs: {
        indicator: {
          height: 5
        }
      },
      MuiTab: {
        root: {
          fontWeight: 'bold'
        }
      }
    }
  });

export default genTheme;
